
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLicenseGoogle as ObiLicenseGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-license-google.js';
 
 
 

 
 export const ObiLicenseGoogle = createComponent({
   react: React,
   tagName: 'obi-license-google',
   elementClass: ObiLicenseGoogleElement,
   events: {
     
   }
  });
 
 